/**
 * @file   : SimpleImageCard.js
 * @author : Amarjeet Lamba (Amarjeet.Lamba@AspiraConnect.com)
 * @date   : 4/11/2019, 3:21:45 PM
 */
import PropTypes from 'prop-types'
import React from 'react'

import Cont from '../../../external/components/layout/Cont'
import ABaseLink from '../../../external/components/link/ABaseLink'
import { createSimpleLinkProps } from '../../../external/components/link/LinkUtils'
import { isEmpty } from '../../../external/utilities/GeneralUtils'
import { ROLES } from '../../../external/utilities/accessibility/Definitions'

const SimpleImageCard = ({
  title,
  linkURL,
  linkInternal = true,
  linkNewWin = false,
  imageURL,
  imageLabel,
}) => {
  const getImageStyle = function () {
    if (!isEmpty(imageURL)) {
      return { backgroundImage: `url(${imageURL})` }
    }

    return null
  }

  return (
    <div className="simple-image-card__container">
      <div className="simple-image-card__image-wrapper">
        <ABaseLink
          {...createSimpleLinkProps(linkURL, linkInternal, linkNewWin)}
        >
          <div className="simple-image-card__image" style={getImageStyle()}>
            <Cont
              asSpan
              cmpSRonly
              cmpRole={ROLES.DOC_STRUCTURE.IMG}
              cmpLabel={imageLabel}
            >
              {imageLabel}
            </Cont>
          </div>
        </ABaseLink>
      </div>
      <div className="simple-image-card__detail">
        <ABaseLink
          {...createSimpleLinkProps(linkURL, linkInternal, linkNewWin)}
        >
          <div className="simple-image-card__title">{title}</div>
        </ABaseLink>
      </div>
    </div>
  )
}

SimpleImageCard.propTypes = {
  title: PropTypes.string.isRequired,
  linkURL: PropTypes.string,
  linkInternal: PropTypes.bool,
  linkNewWin: PropTypes.bool,
  imageURL: PropTypes.string,
  imageLabel: PropTypes.string,
}

export default SimpleImageCard
